import React from 'react';
import PropTypes from 'prop-types';

// app
import styles from './AddProductsFacility.styles';
import { Form } from 'components';

// mui
import { makeStyles } from '@material-ui/core';

AddProductsFacilityView.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  defaultValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired,
};

export function AddProductsFacilityView({ fields, actions, defaultValues, validationSchema }) {
  const classes = makeStyles(styles, { name: 'AddProductsFacility' })();

  return (
    <div className={classes.root}>
      <Form
        id="add-products-facility"
        type="dialog"
        fields={fields}
        actions={actions}
        defaultValues={defaultValues}
        validationSchema={validationSchema}
      />
    </div>
  );
}
